/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventFloor,
    JsonEventFloorFromJSON,
    JsonEventFloorFromJSONTyped,
    JsonEventFloorToJSON,
} from './JsonEventFloor';

/**
 * 
 * @export
 * @interface ApiResultOfJsonEventFloor
 */
export interface ApiResultOfJsonEventFloor {
    /**
     * 
     * @type {JsonEventFloor}
     * @memberof ApiResultOfJsonEventFloor
     */
    data?: JsonEventFloor;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventFloor
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonEventFloor
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventFloor
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventFloor
     */
    result?: ApiResultOfJsonEventFloorResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonEventFloorResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonEventFloorFromJSON(json: any): ApiResultOfJsonEventFloor {
    return ApiResultOfJsonEventFloorFromJSONTyped(json, false);
}

export function ApiResultOfJsonEventFloorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonEventFloor {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonEventFloorFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonEventFloorToJSON(value?: ApiResultOfJsonEventFloor | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonEventFloorToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

